import React from "react";
import {
  ArrowBackCircle,
  ArrowBackOutline,
  ArrowForwardOutline,
  PersonCircle,
  ArrowForwardCircleOutline,
} from "react-ionicons";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesASAP from "./stylesASAP";
import { Modal } from "react-bootstrap";
import stylesMed from "../MedRep/stylesMed";
import { IoMdPersonAdd } from "react-icons/io";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { GoPerson } from "react-icons/go";
import { IoPersonOutline } from "react-icons/io5";
import { BsPerson } from "react-icons/bs";
import { FcManager, FcBarChart, FcBullish, FcBearish , FcCalendar , FcComboChart , FcSurvey , FcSalesPerformance , FcNews , FcSynchronize , FcCancel , FcBusinessman, FcShop } from "react-icons/fc";
import { MdPerson } from "react-icons/md";

export default class Client extends React.Component {
  constructor() {
    super();
    this.state = {
      clients: [],
      clientsCopy: [],
      loading: true,
      data: [],
      noData: true,
      backShow: true,
      token: "",
      showAlertChange: false,
      authenticate: false,
      customer: [],
      isSchedule: "",
      Date: new Date().toISOString().substring(0, 10),
      alertUndefined: false,
      visitin: [],
      disableclient: false,
      scheduledclientid: "",
      cancelreason: [],
      currentType: -1,
      count: 0,
      visitDay: [],
      offset: 0,
      offsetFixed: 0,
      last: "",
      display: [],
      displaycopy: [],
      userId: -1,
      countP: 1,
      clientType: [
        {
          id: 0,
          name: "Customers",
          URL: "GetClients?token=",
          localStorage: "Clients",
        },
        {
          id: 1,
          name: "Vendors",
          URL: "GetVendors?token=",
          localStorage: "Vendors",
        },
      ],
    };
  }

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock();
    }
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    const { history } = this.props;
    this.unblock = history.block(() => {
      // Return false to deny the navigation
      return false;
    });
    const isVendor = JSON.parse(localStorage.getItem("isVendor"));
    isVendor
      ? this.setState({ currentType: 1 })
      : this.setState({ currentType: 0 });

    const token = localStorage.getItem("Token");
    const selectedid = localStorage.getItem("SelectedVisitId");
    const isSchedule = localStorage.getItem("isSchedule");
    const visitin = localStorage.getItem("VisitIn");
    const cancelreason = localStorage.getItem("cancelreason");
    const visitday = localStorage.getItem("UnsyncedVisitDay");
    const countvisit = localStorage.getItem("UnsyncedVisitCount");
    const dayin = localStorage.getItem("DateIn");
    const dayout = localStorage.getItem("DateOut");
    const timein = localStorage.getItem("TimeIn");
    const timeout = localStorage.getItem("TimeOut");
    const userId = localStorage.getItem("UserId");
    await this.setState({
      token: JSON.parse(token),
      isSchedule: JSON.parse(isSchedule),
      dateIn: JSON.parse(dayin),
      dateOut: JSON.parse(dayout),
      timeIn: JSON.parse(timein),
      timeOut: JSON.parse(timeout),
      count: JSON.parse(countvisit),
      visitDay: JSON.parse(visitday),
      visitin: JSON.parse(visitin),
      scheduledclientid: JSON.parse(selectedid),
      cancelreason: JSON.parse(cancelreason),
      backShow: this.props.show,
      userId: JSON.parse(userId),
    });
    if (this.state.isSchedule === 1) {
      this.IsScheduling();
      if (this.state.visitin !== null) {
        var temp = this.state.clients;
        await this.state.clients.map(async (client) => {
          this.state.visitin.map(async (visit) => {
            const lastIndex = temp.length - 1;
            this.state.vIn = temp[lastIndex];
            if (visit.id === client.visitId) {
              client.disableclient = visit.disableout;
              client.cancel = visit.reasondisable;
            }
          });
        });
        this.setState({ clients: temp });
      } else {
        this.setState({ visitin: [] });
      }
    } else {
      //ReadClients from indexDB
      await this.readData();
    }
  }

  readData = async () => {
    //set Vendors
    if (this.state.currentType === 1) {
      const vendors = JSON.parse(localStorage.getItem("Vendors"));
      this.setState({ clients: vendors, clientsCopy: vendors, loading: false });
    } else {
      try {
        // Use 'get' method from idb-keyval to read Clients from IndexedDB
        const data = await get("Clients");

        if (data) {
          this.setState({
            clients: data,
            clientsCopy: data,
            loading: false,
            ofclients: Math.round(data.length / 12),
          });
          console.log("Clients from IndexedDB:", data);
        } else {
          console.log("Clients not found in IndexedDB.");
        }
      } catch (error) {
        console.error("Error reading Clients from IndexedDB:", error);
      }
    }
  };

  handleDelete = (index) => {
    const counters = this.state.clients;
    counters.splice(index, 1);
    this.setState({ clients: counters });
  };
  //Search for client
  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.clients,
      this.state.clientsCopy,
      this.state.noData
    );
    this.setState({
      clients: values.items,
      noData: values.noData,
      offset: 0,
      offsetFixed: 0,
    });
  };

  onButtonClick = (item, page) => {
    localStorage.setItem("ClientId", JSON.stringify(item));
    this.unblock();
    this.props.history.push(page);
  };

  closeAlertChange = () => {
    this.setState({ showAlertChange: false });
  };

  showAlertChange = () => {
    this.setState({ showAlertChange: true });
  };

  moreInfo = (name) => {
    localStorage.setItem("moreinfo", JSON.stringify(name));
    this.unblock();
    this.props.history.push("./MoreInfo");
  };

  EditClient = (name) => {
    localStorage.setItem("SelectedClientName", JSON.stringify(name));
    this.unblock();
    this.props.history.push("./EditClient");
  };

  Sorting = (clientsRank) => {
    clientsRank.sort((a, b) => a.merch_order - b.merch_order);
    this.setState({ clients: clientsRank });
  };
  // enable and disable for visit in and visit out
  isRouting = async () => {
    // Allow visiting scheduled customers in any order:
    // mark all clients as routable if they are not disabled or canceled.
    if (this.state.clients !== null) {
      await this.state.clients.map(async (item) => {
        if (
          (item.disableclient === undefined || item.disableclient === false) &&
          (item.cancel === undefined || item.cancel === false)
        ) {
          item.routing = true;
        } else {
          item.routing = false;
        }
      });
    }
  };
  // scheduling clients today for salesman
  IsScheduling = async () => {
    const client = localStorage.getItem("ScheduledClients");
    await disableNetwork(db).then(async () => {
      await this.readData();
    });
    this.setState({ customer: JSON.parse(client) });

    //Getting Scheduled clients
    var temp = [];
    await this.state.clients.map(async (client) => {
      this.state.customer.map(async (custom) => {
        if (client.name === custom.name) {
          client.visitId = custom.id;
          client.cancelreason = custom.cancel_reason;
          client.routing = false;
          await temp.push(client);
        }
      });
    });

    //Removing duplicates and sorting Clients by order (first, second,...)
    const arr = await this.removeDuplicateObjectFromArray(temp, "id");
    this.setState({ clients: arr, clientsCopy: arr });
    this.Sorting(this.state.clients);

    //Getting last visited clients
    if (this.state.visitin !== null) {
      var temp = this.state.clients;
      await this.state.clients.map(async (client) => {
        this.state.visitin.map(async (visit) => {
          const lastIndex = temp.length - 1;
          this.state.vIn = temp[lastIndex];
          if (visit.id === client.visitId) {
            client.disableclient = visit.disableout;
            client.cancel = visit.reasondisable;
          }
        });
      });
      this.setState({ clients: temp, clientsCopy: temp });
    } else {
      this.setState({ visitin: [] });
    }
    this.isRouting();
    this.setState({ clients: this.state.clients, loading: false });
  };

  removeDuplicateObjectFromArray(array, key) {
    var check = new Set();
    return array.filter((obj) => !check.has(obj[key]) && check.add(obj[key]));
  }

  onClickClient = (id, name, item, visitId , code) => {
    this.unblock();
    localStorage.setItem("SelectedClient", JSON.stringify(id));
    localStorage.setItem("SelectedClientName", JSON.stringify(name));
    localStorage.setItem("SelectedClientDetails", JSON.stringify(item));
    localStorage.setItem("SelectedVisitId", JSON.stringify(visitId));
    localStorage.setItem("SelectedVisitCode", JSON.stringify(code));
    this.props.history.push("./TransactionsPage");
  };

  // Navigate to CompetitorDataLogger for a specific client
  logCompetitor = (item) => {
    this.unblock();
    localStorage.setItem("SelectedClient", JSON.stringify(item.id));
    localStorage.setItem("SelectedClientName", JSON.stringify(item.name));
    localStorage.setItem("SelectedClientDetails", JSON.stringify(item));
    // Navigate to the route registered in App.js
    this.props.history.push("/CompetitorDataLogger");
  };

  selectClient = (id, name, item , code , long , lat) => {
    this.unblock();
    localStorage.setItem("SelectedClient", JSON.stringify(id));
    localStorage.setItem("SelectedClientName", JSON.stringify(name));
    localStorage.setItem("SelectedClientDetails", JSON.stringify(item));
    localStorage.setItem("SelectedVisitCode", JSON.stringify(code));
    localStorage.setItem("LongitudeClient", JSON.stringify(long));
    localStorage.setItem("LatitudeClient", JSON.stringify(lat));
    this.props.history.push("/TransactionsPage");
  };
  // sendingASAP
  onSync = async () => {
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      this.state.visitDay.map(async (day, index, arr) => {
        await _post(day.UrlIn);
        await _post(day.UrlOut);
        await _post(day.cancelUrl);
        if (index === arr.length - 1) {
          await localStorage.setItem("UnsyncedVisitCount", JSON.stringify(0));
          await localStorage.setItem("UnsyncedVisitDay", JSON.stringify([]));
          await alert("Synced Successfully");
          window.location.reload();
        }
      });
    } else {
      alert("Only sync when connected to the Internet!");
      await this.setState({ loading: false });
    }
  };
  //paggination
  onPrevious = async () => {
    await this.setState({
      offset: this.state.offset - 12,
      offsetFixed: this.state.offsetFixed - 1,
      countP: this.state.countP - 1,
    });
    if (this.state.offset < 0) {
      this.setState({ offset: 0, offsetFixed: 0, countP: 1 });
    }
    window.scrollTo(0, 0);
  };
  //paggination
  onNext = async () => {
    await this.setState({
      offset: this.state.offset + 12,
      offsetFixed: this.state.offsetFixed + 1,
      countP: this.state.countP + 1,
    });
    if (
      this.state.clients.slice(this.state.offset, this.state.offset + 9)
        .length === 0
    ) {
      this.setState({
        offset: this.state.offset - 12,
        offsetFixed: this.state.offsetFixed - 1,
        countP: this.state.countP - 1,
      });
    }
    window.scrollTo(0, 0);
  };

  arrowback = () => {
    this.unblock();
    this.props.history.push("./LandingPage");
  };

 


  render() {
    console.log(this.state.clients);
    if (!this.state.loading) {
      return (
        <div
          className="container-fluid vh-100"
          style={stylesASAP.mainContainer}
        >
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className="btn"
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.isSchedule === 1 ? (
            this.state.count === 0 || this.state.count === null ? (
              <div className="alert alert-secondary">
                You have 0 Visit to Sync with Odoo.
              </div>
            ) : (
              <div className="alert alert-danger">
                You have {this.state.count} Visits to Sync with Odoo.
                <h5>Only sync when connected to the Internet!</h5>
              </div>
            )
          ) : null}
          <div className="pt-3">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.arrowback()}
              color={"#65a0ff"}
              height="50px"
              width="50px"
            />
          
         
          </div>
          <div>
            <p className="pt-3 text-center h3">
              {this.state.currentType === 1 ? (
                "Vendors"
              ) : this.state.isSchedule === 2 ? (
                "Clients"
              ) : this.state.isSchedule === 1 ? (
                "Scheduled Clients"
              ) : (
                "Out-of-Route"
              )}
            </p>
          </div>
          <div className="pt-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search Here"
              onInput={(text) => this.onSearch(text)}
            />
          </div>

          <div className="pt-4 m-1">
            <div className="row m-1" style={stylesASAP.mainBackgroundColor}>
              {this.state.clients
                .slice(this.state.offset, this.state.offset + 12)
                .map((item, index) => {
                  return (
                    <div className="col-sm-4 pt-4" key={index}>
                      <div
                        className="card-body bg-light"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (
                            this.state.isSchedule === 1 &&
                            (item.disableclient ||
                              item.cancel ||
                              !item.routing)
                          ) {
                            return;
                          }
                          this.state.isSchedule === 1
                            ? this.onClickClient(
                                item.id,
                                item.name,
                                item,
                                item.visitId,
                                item.Ref
                              )
                            : this.selectClient(
                                item.id,
                                item.name,
                                item,
                                item.Ref,
                                item.partner_longitude,
                                item.partner_latitude
                              );
                        }}
                      >
                        <div
                          className={
                            (!item.disableclient &&
                              !item.cancel &&
                              item.routing &&
                              this.state.isSchedule === 1) ||
                            this.state.isSchedule !== 1
                              ? "text-center "
                              : "text-center  "
                          }
                          style={
                            (!item.disableclient &&
                              !item.cancel &&
                              item.routing &&
                              this.state.isSchedule === 1) ||
                            this.state.isSchedule !== 1
                              ? null
                              : stylesASAP.disabledStyle
                          }
                        >
                          <div
                            className="col"
                            style={stylesASAP.cancelButtonAlert}
                          >
                            <div className="col">
                              <div className="row">
                                {this.state.isSchedule === 1 ? (
                                  <h5 className=" d-flex flex-row-reverse">
                                    Visit : {item.merch_order}
                                  </h5>
                                ) : null}

                                <div className="row">
                                  <div className="text-center">
                                    {" "}
                                    {/* <div className="">
                                    {" "}
                                    <ArrowForwardCircleOutline
                                      className="floatRight"
                                      color={"#00bfff"}
                                      height="40px"
                                      width="40px"
                                    />
                                  </div> */}
                                    <FcBusinessman
                                      color={"#65a0ff"}
                                      size={50}
                                    />
                                  </div>
                                </div>

                                <div
                                  className="row h5 mt-1"
                                  style={{ color: "black" }}
                                >
                                  <b>{item.name}</b>
                                </div>
                                <hr className=" half-line p-1" />
                                <div className="row mb-1 ">
                                  <div
                                    className="col-6 h6 info"
                                    
                                  >
                                    {item.city}
                                  </div>
                                  <div
                                    className="col-6 h6 info"
                                   
                                  >
                                    {" "}
                                    {item.mobile}
                                  </div>
                                </div>
                                {/* Log Competitor removed from Client screen - available in Transactions only */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div className="row " style={stylesMed.mainBackgroundColor}>
            <div className="col">
              <ArrowBackOutline
                className="btn"
                color={"#00bfff"}
                height="50px"
                width="50px"
                onClick={() => this.onPrevious()}
              />
              <h6>Previous clients</h6>
            </div>
            <div className="col text-center">
              <h6>Page {this.state.countP + " of " + this.state.ofclients}</h6>
            </div>
            <div className="col" style={stylesMed.rightDirection}>
              <ArrowForwardOutline
                className="btn"
                color={"#00bfff"}
                height="50px"
                width="50px"
                onClick={() => this.onNext()}
              />
              <h6>Next clients</h6>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className={this.state.disableSync ? "btn disabled" : "btn"}
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="pt-3">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.arrowback()}
              color={"#00bfff"}
              height="50px"
              width="50px"
            />
          </div>
          <div className="pt-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search Here"
              onInput={(text) => this.onSearch(text)}
            />
          </div>
          <p className="pt-3 text-center h3">Clients</p>
          <div className="pt-3 text-center">
            <div className="spinner-border" style={stylesASAP.spinner}></div>
          </div>
        </div>
      );
    }
  }
}
